import styles from './CardKpisSummary.module.css';

export type CardKpiColor = 'success' | 'warning' | 'error' | 'muted';

export interface CardKpiItem {
  key: string;
  /** Etiqueta en mayúsculas (p. ej. "ACTIVAS"). */
  label: string;
  count: number;
  color: CardKpiColor;
  /** Si se provee, la card es clickeable (p. ej. "Sin límite asignado"). */
  onClick?: () => void;
}

export interface CardKpisSummaryProps {
  title: string;
  items: CardKpiItem[];
  isLoading?: boolean;
  className?: string;
}

/**
 * Fila de KPIs de resumen (BF-630). Solo presentacional: recibe etiquetas y
 * conteos por props. Una card con `onClick` se vuelve un botón (aplica su filtro).
 */
export function CardKpisSummary({ title, items, isLoading = false, className }: CardKpisSummaryProps) {
  const classes = [styles.summary, className].filter(Boolean).join(' ');

  return (
    <section className={classes} aria-label={title}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.grid}>
        {items.map((item) => {
          const content = (
            <>
              <span className={styles.label}>
                <span className={`${styles.dot} ${styles[item.color]}`} aria-hidden="true" />
                {item.label}
              </span>
              <span className={styles.count}>{isLoading ? '—' : item.count}</span>
            </>
          );

          return item.onClick ? (
            <button
              key={item.key}
              type="button"
              className={`${styles.card} ${styles.clickable}`}
              onClick={item.onClick}
            >
              {content}
            </button>
          ) : (
            <div key={item.key} className={styles.card}>
              {content}
            </div>
          );
        })}
      </div>
    </section>
  );
}

CardKpisSummary.displayName = 'CardKpisSummary';
